import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PendingTimesheet } from '../models/pending-timesheets.model';

class SelectedTimesheetState {
    selectedTimesheet: PendingTimesheet;
    selectedTimesheets: PendingTimesheet[];
}

const selectedTimesheetSlice = createSlice({
    name: 'selectedTimesheetSlice',
    initialState: {
        selectedTimesheet: {},
        selectedTimesheets: [],
    },
    reducers: {
        setSelectedTimesheet(state: SelectedTimesheetState, action: PayloadAction<PendingTimesheet>) {
            state.selectedTimesheet = action.payload;
        },
        setSelectedTimesheets(state: SelectedTimesheetState, action: PayloadAction<PendingTimesheet[]>) {
            state.selectedTimesheets = action.payload;
        },
        clearSelectedTimesheets(state: SelectedTimesheetState) {
            state.selectedTimesheets = [];
        },
    },
});

export const { setSelectedTimesheet, setSelectedTimesheets, clearSelectedTimesheets } = selectedTimesheetSlice.actions;

export default selectedTimesheetSlice.reducer;
